import { AsyncStoreItem } from '@lib/store';
import { UpdateServicesResponse } from 'src/sdk-servicing';

/**
 * UpdateServices model
 */
export interface UpdateServicesModel {
  model: UpdateServicesResponse | null;
}

/**
 * UpdateServicesResponse model details
 */
export interface UpdateServicesStateDetails extends AsyncStoreItem {}

/**
 * UpdateServices store state
 */
export interface UpdateServicesState extends UpdateServicesStateDetails, UpdateServicesModel {}

/**
 * Name of the UpdateServices Store
 */
export const UPDATE_SERVICES_STORE_NAME = 'updateServices';

/**
 * UpdateServices Store Interface
 */
export interface UpdateServicesStore {
  /** UpdateServices state */
  [UPDATE_SERVICES_STORE_NAME]: UpdateServicesState;
}
